module.exports = __webpack_public_path__ + "img/plane_111.009ad71a.jpg";